import React from 'react';
import Box from '@mui/material/Box';
import AppPage from '../AppPage';
import AppPageTitle, { type AppPageTitleProps } from '../AppPageTitle';

export interface AppListPageProps extends AppPageTitleProps {
  children: React.ReactNode;
}

/** List page: optional title row + table (or other main content). */
const AppListPage: React.FC<AppListPageProps> = ({ title, subheader, description, actions, children }) => (
  <AppPage sx={{ flex: 1, minHeight: 0 }}>
    {title || subheader || description || actions ? (
      <AppPageTitle title={title} subheader={subheader} description={description} actions={actions} />
    ) : null}
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {children}
    </Box>
  </AppPage>
);

export default AppListPage;
